/* eslint-disable prettier/prettier */
/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_4243
 */

import { message } from 'ant-design-vue'
import {
  newSize_getTypes_post,
  newSize_new_modify_post,
  newSize_new_add_post,
  newSize_new_delete_id_get,
  newSize_new_query_id_get,
  newSize_new_modifyStatus_id_status_get,
  newSize_new_page_post
} from 'server/modules/4243'

// type接口
export const newSize_getTypes_post_ = async function (params, state) {
  const { success, data, retInfo } = await newSize_getTypes_post(params)
  if (success) {
    const { allTypes } = data
    state.allTypes = allTypes
  } else {
    message.error(retInfo)
  }
}

// type接口
export const newSize_getTypes_post_copy = async function (params, state) {
  const { success, data, retInfo } = await newSize_getTypes_post(params)
  if (success) {
    const { allTypes } = data
    let allTypes_ = new Array(...allTypes)
    state.allTypes = allTypes_
    let cascaderOptions = []
    allTypes_.map(v => {
      const { typeName, categoryId, nextLevelList } = v
      let list = []
      nextLevelList.map(item => {
        const { typeName, categoryId } = item
        list.push({ typeName, categoryId })
      })
      let node = { typeName, categoryId, nextLevelList: list }
      cascaderOptions.push({ ...node })
    })
    state.cascaderOptions = cascaderOptions
    const flatAllTypes = [...allTypes]
    let empList = []
    empList = state.flatFun(flatAllTypes)
    console.log('empList ', empList)
    state.flatAllTypes = empList
  } else {
    message.error(retInfo)
  }
}

export const newSize_getTypes_post_copy_v2 = async function (params, state) {
  const { success, data, retInfo } = await newSize_getTypes_post(params)
  if (success) {
    const { allTypes } = data
    let allTypes_ = new Array(...allTypes)
    let cascaderOptions = []
    allTypes_.map(v => {
      const { typeName, categoryId, nextLevelList } = v
      let list = []
      nextLevelList.map(item => {
        const { typeName, categoryId } = item
        list.push({ typeName, categoryId })
      })
      let node = { typeName, categoryId, nextLevelList: list }
      cascaderOptions.push({ ...node })
    })
    state.cascaderOptions = cascaderOptions

    state.cascaderOptionsv2 = allTypes_


  } else {
    message.error(retInfo)
  }
}

// 修改接口
export const newSize_new_modify_post_ = async function (params) {
  const { success, data, retInfo } = await newSize_new_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增接口
export const newSize_new_add_post_ = async function (params) {
  const { success, data, retInfo } = await newSize_new_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除单个测量方式
export const newSize_new_delete_id_get_ = async function (params) {
  const { success, data, retInfo } = await newSize_new_delete_id_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询单个测量方式
export const newSize_new_query_id_get_ = async function (params) {
  const { success, data, retInfo } = await newSize_new_query_id_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 启用/禁用
export const newSize_new_modifyStatus_id_status_get_ = async function (params) {
  const {
    success,
    data,
    retInfo
  } = await newSize_new_modifyStatus_id_status_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询接口
export const newSize_new_page_post_ = async function (params) {
  const { success, data, retInfo } = await newSize_new_page_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
